import { CrownSimpleIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Crown = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CrownSimpleIcon {...rest} size={Sizes[size]} color={fill} />;
};

Crown.displayName = 'Crown';
